<template>
	<div class="loading-block">
		<div class="lb-spinner"></div>
		<p>{{ text }}</p>
	</div>
</template>

<script>
// 通用加载中占位：接口返回前显示，返回后(成功或失败)由父组件 v-if 取消
export default {
	name: 'LoadingBlock',
	props: {
		text: { type: String, default: '加载中...' },
	},
}
</script>

<style scoped>
.loading-block { text-align: center; padding: 3rem 1rem; color: #94a3b8; }
.lb-spinner {
	width: 28px;
	height: 28px;
	margin: 0 auto .7rem;
	border: 3px solid #e2e8f0;
	border-top-color: #2563eb;
	border-radius: 50%;
	animation: lb-spin .8s linear infinite;
}
@keyframes lb-spin { to { transform: rotate(360deg); } }
.loading-block p { margin: 0; font-size: .9rem; }
</style>
